﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';

import React, { useContext, useEffect, useState, Fragment } from 'react';
import ReactDOM from 'react-dom';
import URLSearchParams from '@ungap/url-search-params'
import moment from 'moment';

import { useJsApiLoader } from '@react-google-maps/api';
import { FacilitySearchContextProvider, FacilitySearchContext } from './FacilitySearchContext'
import { search } from './Endpoints'

import TextboxWidget from './partials/Textbox'
import MapWidget from './partials/Map'
import ListWidget from './partials/List'
import ControlsWidget from './partials/Controls'
import FiltersWidget, { FilterFacilities } from './partials/Filters'
import AdvFiltersWidget, { FilterFacilities } from './partials/AdvFilters'
import LoadingScreenWidget from './partials/LoadingScreen'
import { parseDate } from '../../../../Resources/Scripts/_Shared/parseDate'


function facilitySearchPage(context) {
  let country = document.querySelector('html').getAttribute('country');
  const appConfig = controller.getConfig(context);
  const customerService = appConfig.episerver.pagetype === 'customerservice';
  const urlParams = new URLSearchParams(window.location.search);

  const App = ({ isLoaded }) => {
    const { facilitySearchContext, setFacilitySearchContext } = useContext(FacilitySearchContext);
    const [viewToggle, setViewToggle] = useState('list');
    const [selectedLocationFallback, setSelectedLocationFallback] = useState({});
    const [facilitiesChecked, setFacilitiesChecked] = useState(false);
    const advSearch = facilitySearchContext.advSearch;
    const showAdvancedFilters = facilitySearchContext.showAdvancedFilters;
    
    const getCoords = () => {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    }

    const getUserLocation = async () => {
      const position = await getCoords()
        .catch(error => console.log(error))
      return getSelectedLocationFallback(position);
    };

    const getSelectedLocationFallback = (position) => {
      const limits = {
        se: { lat: { min: 55.3, max: 68.5 }, lng: { min: 10.9, max: 24.2 } },
        fi: { lat: { min: 59.5, max: 70.1 }, lng: { min: 20.5, max: 31.6 } },
        no: { lat: { min: 57.5, max: 71.2 }, lng: { min: 4.5, max: 31.6 } }
      }
      if (position && position.coords.latitude >= limits[country].lat.min && position.coords.latitude <= limits[country].lat.max && position.coords.longitude >= limits[country].lng.min && position.coords.longitude <= limits[country].lng.max) {
        setSelectedLocationFallback({ name: 'georesult', position: { lat: position.coords.latitude, lng: position.coords.longitude } });
        sessionStorage.setItem("userLocation", JSON.stringify({ name: 'georesult', position: { lat: position.coords.latitude, lng: position.coords.longitude } }))
      }
      else setSelectedLocationFallback(
        country === 'se' ? { name: 'Stockholm', position: { lat: 59.3311075, lng: 18.0529781 } } : country === 'fi' ? { position: { lat: 60.1698556, lng: 24.9383791 } } : { position: { lat: 59.9138688, lng: 10.7522454 } });
    }

    if (!urlParams.get('lat') && Object.keys(selectedLocationFallback).length === 0) {
      if (sessionStorage.getItem("userLocation")) setSelectedLocationFallback(JSON.parse(sessionStorage.getItem("userLocation")));
      else if (navigator.geolocation) {
        getUserLocation();
      } else getSelectedLocationFallback();
    } else if (Object.keys(selectedLocationFallback).length === 0) getSelectedLocationFallback();

    useEffect(() => {
      if (Object.keys(selectedLocationFallback).length === 0 || facilitiesChecked) return;
      let isSubscribed = true;

      const stored = window.sessionStorage.getItem('selected_date') ? JSON.parse(window.sessionStorage.getItem('selected_date')) : undefined;
      const addDays = 0;
      const startDate = moment().add(addDays, 'days').toDate();
      const endDate = moment().add(1, 'year').toDate();
      let storedDate = "";
      if (stored) {
        const parsedDate = parseDate(stored.date);
        if (moment(parsedDate).isBefore(startDate, 'day') || moment(parsedDate).isAfter(endDate, 'day')) window.sessionStorage.removeItem('selected_date');
        else storedDate = moment(parsedDate).locale('sv').format('L');
      }

      const getFacilities = async () => {
        if (facilitySearchContext.allFacilities)
          return;

        const selectedLocation = urlParams.get('name') ? {
          name: urlParams.get('name'),
          address: urlParams.get('address'),
          position: {
            lat: urlParams.get('lat') && parseFloat(urlParams.get('lat')),
            lng: urlParams.get('lng') && parseFloat(urlParams.get('lng')),
          },
        } : selectedLocationFallback;

        const urlFilterSelection = urlParams.get('f') ? urlParams.get('f').split(',') : advSearch ? ['LTP'] : '';
        const urlParkingSpaceTypeSelection = urlParams.get('p') ? urlParams.get('p').split(',') : null;
        const initFilterSelection = { ParkingSpaceTypeSelection: {} };
        if (urlFilterSelection) urlFilterSelection.map(filter => initFilterSelection[filter] = true);
        if (initFilterSelection.STP) initFilterSelection.LTP = false;
        if (urlParkingSpaceTypeSelection) urlParkingSpaceTypeSelection.map(filter => initFilterSelection.ParkingSpaceTypeSelection[filter] = true);
        const lastKnownLocation = selectedLocation ? selectedLocation.position : null;
        const initContext = {
          ...facilitySearchContext,
          country,
          customerService,
          searchDate: urlParams.get('date') ?? storedDate ?? "",
          selectedLocation,
          isSearchButtonDisabled: !showAdvancedFilters,
          lastKnownLocation,
          filterSelection: {
            ...facilitySearchContext.filterSelection, ...initFilterSelection
          },
          ...appConfig,
        };
        
        if (isSubscribed)
          setFacilitySearchContext(initContext);

        const facilitySearchPageWrapper = document.querySelector(".facilitysearchpage__wrapper");
        if (initFilterSelection.STP) facilitySearchPageWrapper.classList.add('STP');

        const allFacilities = (customerService && !urlParams.get('name')) ? { status: 200, body: [] } : selectedLocation ? await search.getNearbyFacilities({ lang: appConfig.episerver.selectedlanguage, location: selectedLocation.position, init: true }) : null;

        if (allFacilities && allFacilities.status === 200 && isSubscribed && allFacilities.body.length > 0) {
          setFacilitiesChecked(true);

          const filteredFacilities = (urlFilterSelection || urlParkingSpaceTypeSelection) ? FilterFacilities(allFacilities.body, initContext.filterSelection) : allFacilities.body;

          const hasUrlFilters = advSearch ? urlFilterSelection.length > 1 : urlFilterSelection.length > 0;

          setFacilitySearchContext({
            ...initContext,
            allFacilities: allFacilities.body,
            filteredFacilities,
            panOnLoad: !(hasUrlFilters || urlParkingSpaceTypeSelection),
            updateMapBounds: !facilitySearchContext.init && !!((hasUrlFilters && filteredFacilities.length) || (urlParkingSpaceTypeSelection && urlParkingSpaceTypeSelection.length)),
            filterOnInit: !!((hasUrlFilters && filteredFacilities.length) || (urlParkingSpaceTypeSelection && filteredFacilities.length)),
            showLoadingScreen: !((hasUrlFilters && !filteredFacilities.length) || (urlParkingSpaceTypeSelection && !urlParkingSpaceTypeSelection.length))
            
          })
        } else {
          if (isSubscribed) setFacilitiesChecked(true);
          setFacilitySearchContext({
            ...initContext,
            allFacilities: [],
            filteredFacilities: [],
            showLoadingScreen: false,
            panOnLoad: false
          })
        }
      }
      getFacilities();

      return () => isSubscribed = false;
    }, [selectedLocationFallback])


    if (!isLoaded || Object.keys(selectedLocationFallback).length === 0 || !facilitiesChecked) {
      return <LoadingScreenWidget />
    }

    return (
      <Fragment>
        <ControlsWidget
          facilitySearchContext={facilitySearchContext}
          setFacilitySearchContext={setFacilitySearchContext}
          viewToggle={viewToggle}
          setViewToggle={setViewToggle}
        >
          <TextboxWidget
            isLoaded={isLoaded}
            facilitySearchContext={facilitySearchContext}
            setFacilitySearchContext={setFacilitySearchContext}
          />
        </ControlsWidget>
        <Fragment>
          <MapWidget
            isLoaded={isLoaded}
            facilitySearchContext={facilitySearchContext}
            setFacilitySearchContext={setFacilitySearchContext}
            viewToggle={viewToggle}
          />
          <ListWidget
            facilitySearchContext={facilitySearchContext}
            setFacilitySearchContext={setFacilitySearchContext}
            viewToggle={viewToggle}
          />
          {!advSearch && <FiltersWidget
            facilitySearchContext={facilitySearchContext}
            setFacilitySearchContext={setFacilitySearchContext}
          />}
        </Fragment>
      </Fragment>
    );
  }

  const ProviderWrapper = ({ scriptLib }) => {
    const { isLoaded } = useJsApiLoader(scriptLib);

    return (
      <FacilitySearchContextProvider>
        <App isLoaded={isLoaded} />
      </FacilitySearchContextProvider>
    )
  }

  function init() {
    const scriptLib = { googleMapsApiKey: appConfig.episerver.apikey, libraries: ['places', 'marker'] };
    ReactDOM.render(<ProviderWrapper scriptLib={scriptLib} />, context);
  }

  return {
    init
  };
}

controller.add('facility-search-page', facilitySearchPage);
